import Vue from 'vue'

export default function () {
  Vue.swal({
    title: '<div style="color:red;">Instabilidade API e-CAC</div>',
    html: `
          '<div style="color:red; font-size: 18px;">
            Olá!
            <br>
            Informamos que estamos <b>enfrentando instabilidades temporárias na integração com a API do e-CAC</b>, o que pode causar lentidão ou dificuldades no acesso a algumas informações.
            Nossa equipe técnica já está ciente da situação e atua ativamente para normalizar os serviços o mais breve possível.
            Reforçamos nosso compromisso com a estabilidade e transparência, e manteremos você informado(a) sobre qualquer atualização relevante.
            Caso precise de suporte adicional, nossa equipe está à disposição para ajudar.
            <br><br><br>
            <b>Atenciosamente
            Equipe Monitor Contábil</b>
            </div>'
      `,
    icon: 'warning',
    iconColor: '#FF0000',
    showConfirmButton: false,
    width: '30%',
    customClass: {
      popup: 'swal-m',
    },
  })
}
